import { Button, Checkbox, DatePicker, Modal, Typography } from "antd";
import { Table } from "../../../components";
import "./statistic-modal.scss";
import { ColumnsType } from "antd/lib/table";
import { DateFormat } from "../../../constants";
import { Department } from "../../../services/department-viags/department.service";
import { DocsByDepartmentType } from "../../../services/department-viags/statistics-employee.service";
import { Moment } from "moment";
import { getDDMMYYYFormat } from "../../../helper/dateTimeHelper";
import { useSearchParams } from "../../../hook/use-search-params";
import { useDocByDepartment } from "../hooks/use-doc-by-department";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { useState } from "react";
type UseDocumentModalType = {
  onClose: () => void;
  isOpen: boolean;
  selectedDepartment: Department;
};

type RangeValue = [Moment | null, Moment | null] | null;

const { RangePicker } = DatePicker;

export const DepartmentDocumentModal = (props: UseDocumentModalType) => {
  const { onClose, isOpen, selectedDepartment } = props;
  const {
    filteredData: docsByDepartmentData,
    countExternalDocument,
    countInternalDocument,
    countTotal,
    countSQMSDocument,
  } = useDocByDepartment();

  const { searchParams, pushSearchParams } = useSearchParams();
  const [isColunmVisible, setColunmVisible] = useState<boolean>(false);

  const startStringDate = searchParams.get("start");
  const endStringDate = searchParams.get("end");

  const dateStartFormated = dayjs(startStringDate).format("DD-MM-YYYY");
  const dateEndFormated = dayjs(endStringDate).format("DD-MM-YYYY");

  const titleOfExcelFile =
    startStringDate && endStringDate
      ? `Danh sách đơn vị/cá nhân nhận tài liệu thời gian từ ${dateStartFormated} đến ${dateEndFormated}`
      : "Danh sách đơn vị/cá nhân nhận tài liệu thời gian từ.............đến............";

  const columns: ColumnsType<any> = [
    {
      title: "Mã tài liệu",
      dataIndex: "docCode",
      key: "docCode",
      align: "center" as const,
      width: 120,
    },
    {
      title: "Tên tài liệu",
      dataIndex: "docName",
      key: "docName",
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      key: "docType",
    },
    {
      title: "Tình Trạng",
      dataIndex: "docStatus",
      key: "docStatus",
    },
    {
      title: "Ngày hiệu lực",
      dataIndex: "publishDay",
      key: "publishDay",
      render: (date: string) => getDDMMYYYFormat(date),
    },

    {
      title: "SL đã đọc",
      dataIndex: "quantityRead",
      key: "quantityRead",
      render: (isRead: any) => isRead,
      align: "center" as const,
    },
    {
      title: "Tỉ lệ đã đọc",
      key: "readedPercent",
      render: (data: { quantityRead: number; quantityUnread: number }): string => {
        const percentage = (data.quantityRead / (data.quantityRead + data.quantityUnread)) * 100;
        if (percentage % 1 === 0) {
          return percentage + "%";
        } else {
          return percentage.toFixed(2) + "%";
        }
      },
      align: "center" as const,
    },
    {
      title: "SL chưa đọc",
      dataIndex: "quantityUnread",
      key: "quantityUnread",
      render: (isRead: any) => isRead,
      align: "center" as const,
    },
    {
      title: "Tỉ lệ chưa đọc",

      key: "unreadPercent",

      render: (data: { quantityRead: number; quantityUnread: number }): string => {
        const percentage = (data.quantityUnread / (data.quantityRead + data.quantityUnread)) * 100;
        if (percentage % 1 === 0) {
          return percentage + "%";
        } else {
          return percentage.toFixed(2) + "%";
        }
      },
      align: "center" as const,
    },
    {
      title: "Ngày ban hành",
      dataIndex: "publishDay",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "publishDay",
      className: `${isColunmVisible ? "block" : "d-none"}`,
    },
    {
      title: "Ngày hết hiệu lực",
      dataIndex: "effectiveDate",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "effectiveDate",
      className: `${isColunmVisible ? "block" : "d-none"}`,
    },
  ];

  const onDateChange = (dates: RangeValue) => {
    if (dates) {
      const [startDate, endDate] = dates;
      searchParams.set("start", startDate?.startOf("month").startOf("day")?.toISOString() || "");
      searchParams.set("end", endDate?.endOf("month").endOf("day")?.toISOString() || "");
      pushSearchParams(searchParams);
    } else {
      searchParams.delete("start");
      searchParams.delete("end");
      pushSearchParams(searchParams);
    }
  };

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();

    let result: any = docsByDepartmentData?.map((dbp: DocsByDepartmentType) => {
      return {
        ...dbp,
        publishDay: getDDMMYYYFormat(dbp.publishDay),
        effectiveDate: getDDMMYYYFormat(dbp.effectiveDate),
        readedPercent:
          dbp.quantityRead !== undefined && dbp.quantityUnread !== undefined
            ? (dbp.quantityRead / (dbp.quantityRead + dbp.quantityUnread)) * 100
            : 0,
        unreadPercent:
          dbp.quantityRead !== undefined && dbp.quantityUnread !== undefined
            ? (dbp.quantityUnread / (dbp.quantityRead + dbp.quantityUnread)) * 100
            : 0,
      };
    });

    const exportContent = {
      fileName: "DanhSachPhanPhoiTaiLieu.xlsx",
      sheet: "Sheet 1",
      content: [
        { header: "Mã tài liệu", dataIndex: "docCode" },
        { header: "Tên tài liệu", dataIndex: "docName" },
        { header: "Loại tài liệu", dataIndex: "docType" },
        { header: "Tình Trạng", dataIndex: "docStatus" },
        { header: "Ngày hiệu lực", dataIndex: "publishDay" },
        { header: "SL đã đọc", dataIndex: "quantityRead" },
        { header: "Tỉ lệ đã đọc", dataIndex: "readedPercent" },
        { header: "SL chưa đọc", dataIndex: "quantityUnread" },
        { header: "Tỉ lệ chưa đọc", dataIndex: "unreadPercent" },
        { header: "Ngày ban hành", dataIndex: "publishDay" },
        { header: "Ngày hết hiệu lực", dataIndex: "effectiveDate" },
      ],
    };

    const worksheet = workbook.addWorksheet(exportContent.sheet);

    //* Defind colunms based on export content
    worksheet.mergeCells("A1:K2");
    worksheet.getCell("A1").value = titleOfExcelFile;
    worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
    worksheet.getCell("A1").font = { bold: true, size: 14 };

    //* Set header value row
    const headerRow = worksheet.getRow(3);
    headerRow.values = exportContent.content.map((col) => col.header);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };

    //* Add data row
    exportContent.content.forEach((_col, index) => {
      worksheet.getCell(3, index + 1).font = { bold: true };
    });

    //* Add data rows
    result.forEach((data: any) => {
      const row = exportContent.content.map((col) => data[col.dataIndex]);
      const dataRow = worksheet.addRow(row);

      dataRow.font = { bold: false };
    });

    worksheet.columns.forEach((column) => {
      if (column && column.eachCell) {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value ? cell.value.toString().length : 10;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        column.width = Math.min(maxLength + 2, 30);
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), exportContent.fileName);
  };

  return (
    <Modal
      open={isOpen}
      zIndex={1552}
      width={1440}
      cancelText="Đóng"
      centered
      onCancel={onClose}
      okButtonProps={{ hidden: true }}
      closable={false}
    >
      <div className="modal-title">
        <div className="modal-left">
          <h5 style={{ color: "#00a9c4" }}>Bảng thống kê danh sách tài liệu ban hành cho cơ quan đơn vị</h5>
          <div className="d-flex column">
            <p className="mx-2">
              <span style={{ fontWeight: "bold" }}>Tài liệu ban hành đến: </span>
              {selectedDepartment?.name}
            </p>
          </div>
          <div className="d-flex column">
            <p className="mx-2">
              Tổng cộng: <span>{countTotal}</span>
            </p>
            <p className="mx-2">
              SL Tài liệu nội bộ: <span>{countInternalDocument}</span>
            </p>
            <p className="mx-2">
              SL Tài liệu bên ngoài: <span>{countExternalDocument}</span>
            </p>
            <p className="mx-2">
              SL Tài liệu SQMS: <span>{countSQMSDocument}</span>
            </p>
          </div>
        </div>
        <div className="modal-right">
          <div className="py-2 modal-date-picker">
            <span className="modal-date-text">Thời gian ban hành/triển khai</span>
            <RangePicker
              popupStyle={{ zIndex: 1553 }}
              onChange={onDateChange}
              style={{ width: "55%", height: "40px" }}
              placeholder={["Ngày bắt đầu", "Ngày kết thúc"]}
              format={DateFormat.DD_MM_YYY}
            />
          </div>
          <Button type="primary" onClick={handleExport}>
            Xuất excel
          </Button>
        </div>
      </div>

      <div className="px-0 pb-0 modal-body">
        <div className="d-flex justify-content-end">
          <Typography.Text className="mb-1 mr-3">Hiện thêm cột</Typography.Text>
          <Checkbox checked={isColunmVisible} onChange={(value) => setColunmVisible(value.target.checked)} />
        </div>
        <Table rowKey="id" columns={columns} showHeader={true} dataSource={docsByDepartmentData} />
      </div>
    </Modal>
  );
};
